<button
      type="button"
      class="support-ticket-map-btn"
      title="Create support ticket"
      (click)="openSupportTicketCreation()">
      <img src="/assets/img/help-white.svg" alt="" />
    </button>
